import { useEffect, useState } from "react";
import { fetchEngineAccounts } from "../lib/paper/manualApi";

const POLL_MS = 15000;

// Read-only snapshot of the autonomous-engine paper accounts and their open
// positions. Nothing here can write to those accounts.
export default function useEngineAccounts() {
  const [data, setData] = useState({ accounts: [], positions: [], error: null, loaded: false });

  useEffect(() => {
    let live = true;
    const load = async () => {
      if (document.hidden) return;
      try {
        const d = await fetchEngineAccounts();
        if (live) setData({ ...d, error: null, loaded: true });
      } catch (e) {
        if (live) setData((x) => ({ ...x, error: e?.message || "Engine accounts unavailable", loaded: true }));
      }
    };
    load();
    const id = setInterval(load, POLL_MS);
    return () => { live = false; clearInterval(id); };
  }, []);

  return data;
}
